import React, { Component } from 'react';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import {AppBar, Toolbar, Typography, Paper, CardContent, TextField, CardActions, Button, CircularProgress, List, ListItem, ListItemIcon} from '@material-ui/core';

class DashboardContainer extends Component {
    constructor() {
        super();
        this.state = {fbc: false};
    }

    fbResp() {
        this.setState({fbc: true});
    }

    render() {
        return <CardContent>
              <Typography variant="headline">Hello, Sam!</Typography>
              <div className="spacer"></div>  
              Connected networks:
              <List>
                {(this.state.fbc)? <ListItem button><ListItemIcon><img src="messenger.png" height="30" /></ListItemIcon> Facebook Messenger</ListItem>
                 : <ListItem>None! Select a network below to get started.</ListItem>}
              </List>
              <div className="spacer"></div>
              Available networks:
              <List>
                {(this.state.fbc)?"":<FacebookLogin appId="1998686230197921" autoload={true} fields="name,email,picture" render={renderProps => 
                    <ListItem button onClick={renderProps.onClick}><ListItemIcon><img src="messenger.png" height="30" /></ListItemIcon> Facebook Messenger</ListItem>
                } callback={this.fbResp.bind(this)} />}
                <ListItem button><ListItemIcon><img src="whatsapp.png" height="35" /></ListItemIcon> WhatsApp</ListItem>
                <ListItem button><ListItemIcon><img src="telegram.png" height="30" /></ListItemIcon> Telegram</ListItem>
                <ListItem button><ListItemIcon><img src="slack.png" height="30" /></ListItemIcon> Slack</ListItem>
              </List>
            </CardContent>;
    }
}

export default DashboardContainer;